import classNames from "classnames";
import * as React from "react";
import { PropsWithChildren } from "react";
import "./WidgetToolbar.scss";

interface IWidgetToolbarProps {
    hidden?: boolean;
    displayLayerIds?: string[];
    className?: string;
}

export const WidgetToolbar = (props: PropsWithChildren<IWidgetToolbarProps>): JSX.Element => {
    return (
        <div className={classNames("widget-toolbar", props.className)}>{props.children ? props.children : null}</div>
    );
};
